import Reveal from '@/components/feature/Reveal';
import SectionHeading from './SectionHeading';
import { topics } from '@/mocks/guide';

export default function TopicGrid() {
  return (
    <section id="topics" className="w-full bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <SectionHeading
          kicker="TOPICS"
          title="热门投稿主题：你的线索属于哪一类"
          desc="同样的格式要求，套用到不同主题上侧重点会有差异。先找到对应的主题，再按该主题习惯补充材料，采纳效率更高。"
        />

        <div className="mt-10 md:mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {topics.map((topic, index) => (
            <Reveal key={topic.name} delay={(index % 3) * 80}>
              <article className="group h-full p-5 md:p-6 rounded-lg bg-background-100 border border-background-200 cursor-pointer transition-all hover:border-primary-400 hover:bg-background-50">
                <div className="flex items-start justify-between gap-3">
                  <span className="w-11 h-11 flex items-center justify-center rounded-md bg-background-50 text-primary-700 border border-background-200 group-hover:bg-primary-500 group-hover:text-background-50 group-hover:border-primary-500 transition-colors">
                    <i className={`${topic.icon} text-2xl`} aria-hidden="true" />
                  </span>
                  <span className="text-xs text-foreground-500 bg-background-200/70 px-2.5 py-1 rounded-full">{topic.count}</span>
                </div>
                <h3 className="mt-4 font-heading font-semibold text-lg text-foreground-950">{topic.name}</h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{topic.desc}</p>
                <span className="mt-4 inline-flex items-center gap-1 text-sm text-primary-700">
                  查看投稿要点
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" aria-hidden="true" />
                </span>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}